// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3g46V","rightAdornment":"Header_rightAdornment__3eRwG"};